export function setMobile(value) {
  return {
    type: 'SET_MOBILE',
    value
  }
}

export function setWindowHeight(value) {
  return {
    type: 'SET_WINDOW_HEIGHT',
    value
  }
}


// WEBPACK FOOTER //
// ./src/actions/ConfigActions.js